import React, { useMemo, useState, useEffect } from "react";
import "./AIAlertsSignup.scss";
import { Button, Modal, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ContactForm from "../EmeraldSignup/ContactForm";
import { useHistory } from "react-router-dom";
import AIAlertsLogo from "../../assets/images/ai-alerts/logo.png";
import {
  StrategyIcon,
  StorageIcon,
  RationaleIcon,
  SecurityIcon,
} from "../common/Icon/AIAlerts";
import { connect } from "react-redux";
import { useAuth } from "../../contexts/Auth";
import moment from "moment";
import BeautifulSkeleton from "../common/Skeletons/BeautifulSkeleton";
import AIAlertsMobileView from "./AIAlertsMobileView";

const AIAlertsSignup = ({ userSettings }) => {
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory();

  const { loading, hasAiOptionsAlertsNeural } = useAuth();

  // Redirect to /live if user already has neural access
  useEffect(() => {
    if (!loading && hasAiOptionsAlertsNeural) {
      history.replace("/ai-options-alerts/live");
    }
  }, [loading, hasAiOptionsAlertsNeural, history]);

  const hasSubmitted = useMemo(() => {
    const submitDate = userSettings?.aiAlertsContact;
    const weekSinceSubmit = moment(submitDate).add(1, "week");
    const today = moment();
    return submitDate ? today.isBefore(weekSinceSubmit) : false;
  }, [userSettings, loading]);

  const handleContactSales = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleClose = () => {
    history.goBack();
  };

  return (
    <div className="ai-alerts-signup">
      {/* Close Button */}
      <IconButton className="ai-alerts-close-button" onClick={handleClose}>
        <CloseIcon />
      </IconButton>

      <div className="ai-alerts-signup-content">
        {/* Header with Logo and Title */}
        <div className="ai-alerts-header">
          <div className="ai-alerts-logo">
            <img
              src={AIAlertsLogo}
              alt="AI Options Alerts"
              className="ai-alerts-logo-icon"
            />
            <div className="ai-alerts-logo-text">AI Options Alerts</div>
          </div>
        </div>

        {/* Description */}
        <p className="ai-alerts-description">
          Access options trade ideas generated by our AI models, with intraday
          updates on key changes in each alert.
        </p>

        {/* Mobile View (shows at 850px and below) */}
        <AIAlertsMobileView />

        {/* Pricing Cards (hidden on mobile) */}
        <div className="ai-alerts-pricing-cards">
          {/* Neural Tier */}
          <div className="ai-alerts-pricing-card">
            <div className="pricing-card-header">
              <h3 className="pricing-card-title gradient-text">Neural</h3>
            </div>

            <div className="pricing-card-features">
              <div className="feature-item">
                <div className="feature-header">
                  <StrategyIcon />
                  <span className="feature-label">STRATEGY STACK</span>
                </div>
                <p className="feature-value">Single-leg long calls/put</p>
              </div>

              <div className="feature-item">
                <div className="feature-header">
                  <StorageIcon />
                  <span className="feature-label">DATA PROVISION</span>
                </div>
                <p className="feature-value">Unusual Activity</p>
              </div>

              <div className="feature-item">
                <div className="feature-header">
                  <RationaleIcon />
                  <span className="feature-label">RATIONALE</span>
                </div>
                <p className="feature-value">Risk Scoring</p>
              </div>

              <div className="feature-item">
                <div className="feature-header">
                  <SecurityIcon />
                  <span className="feature-label">RISK MANAGEMENT</span>
                </div>
                <p className="feature-value">Stop Loss, Take Profit</p>
              </div>
            </div>

            {loading ? (
              <BeautifulSkeleton width="100%" height={42} />
            ) : (
              <Button
                variant="contained"
                className="pricing-card-button primary-button"
                onClick={handleContactSales}
                disabled={hasSubmitted}
              >
                {hasAiOptionsAlertsNeural
                  ? "You're currently on this plan."
                  : hasSubmitted
                    ? "Access Requested"
                    : "Contact sales"}
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Modal for Contact Form */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <ContactForm
          product_type="AI OPTIONS ALERTS"
          onClose={handleCloseModal}
        />
      </Modal>
    </div>
  );
};

const stateToProps = (state) => ({
  userSettings: state.userSettings.userSettings,
});

export default connect(stateToProps)(AIAlertsSignup);
